import React, { useState } from "react";

import { Box, Button, TextField, Typography } from "@mui/material";
import {
  RiAddCircleLine,
  RiCloseCircleLine,
  RiSearchLine,
  RiArrowLeftLine,
} from "react-icons/ri";
import { useNavigate } from "react-router-dom";

import CompanyBranchList from "./CompanyBranchList";

const CompanyBranch = () => {
  const navigate = useNavigate();
  const [searchBranch, setSearchBranch] = useState();

  const clearSearchHandler = () => {
    setSearchBranch("");
  };
  return (
    <>
      {/*  START :: BRANCH VIEW */}
      <Box className="content-header project-list-header setting-asset-category-module-wrapper">
        <Typography variant="h2" component="h2" className="title-with-btn">
          <Button
            variant="outlined"
            className="action-btn back-btn"
            startIcon={<RiArrowLeftLine />}
            disableRipple
            onClick={() => navigate("/settings")}
          ></Button>
          Company Branches
        </Typography>
        <Box variant="div" component="div" className="content-header-right">
          <Box variant="div" component="div" className="search-bar">
            <RiSearchLine />
            <TextField
              fullWidth
              id="outlined-basic-search"
              label=""
              variant="outlined"
              size="small"
              placeholder="Search"
              onChange={(e) => setSearchBranch(e.target.value)}
              value={searchBranch}
            />
            {searchBranch && (
              <RiCloseCircleLine
                className="cross-line"
                onClick={clearSearchHandler}
              />
            )}
          </Box>
          <Button
            variant="contained"
            size="large"
            className="primary-btn btn add-btn"
            endIcon={<RiAddCircleLine />}
            disableRipple
            onClick={() => navigate("/branch/create")}
          >
            Create Company Branch
          </Button>
        </Box>
      </Box>
      <Box className="content-layout">
        <CompanyBranchList searchBranch={searchBranch} />
      </Box>
      {/* END :: BRANCH VIEW */}
    </>
  );
};

export default CompanyBranch;
